/**
 * JELSZÓMEZŐ MEGJELENÍTŐ-KAPCSOLÓVAL — a „szemgolyó" az ügyfélnek is (#57).
 *
 * AZ ADMIN PÁRJA (`admin-node-vite-react/src/components/common/PasswordInput.tsx`,
 * #30), ugyanazzal a szerződéssel. Ott áll a három döntés indoklása:
 * `type="button"` (különben beküldené az űrlapot), nincs `tabIndex={-1}`
 * (billentyűzetről is elérhető), és nincs időzített visszarejtés.
 *
 * ⚠️ KÉT PÉLDÁNY, KÉT SZERVIZBEN. A `packages/` ma tokeneket, szótárat és
 * szerződést oszt meg, komponenst nem — egy közös React-csomag több, mint
 * amit két fájl indokol. Ha egy harmadik felületen is kell, akkor költözzön.
 *
 * AMIBEN ELTÉR AZ ADMINTÓL: a gomb 44px-es érintőfelület. Az ügyfél
 * telefonon gépeli be a jelszót, és pont a mobil billentyűzeten gyakori az
 * elütés — itt ér a legtöbbet a „megnézem, mit írtam".
 */

import { type InputHTMLAttributes, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EyeIcon } from './icons';

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export function PasswordInput(props: PasswordInputProps) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <span className="password">
      {/* ⚠️ FELFEDVE A MEZŐ `type="text"` — és telefonon a szövegmezőt a
          billentyűzet „segíti": nagybetűvel kezd, kijavítja a szót, és
          megtanulja. Egy jelszóban mindhárom kár, pont a „megnézem, mit
          írtam" pillanatában. Ezért kapcsoljuk ki előre; a hívó felülírhatja. */}
      <input
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        {...props}
        type={visible ? 'text' : 'password'}
      />
      <button
        type="button"
        className="password__reveal"
        // Az `aria-pressed` az ÁLLAPOT, az `aria-label` a következő MŰVELET.
        aria-pressed={visible}
        aria-label={visible ? t('password.hide') : t('password.show')}
        onClick={() => setVisible((current) => !current)}
      >
        <EyeIcon off={visible} />
      </button>
    </span>
  );
}
